import type { UserResource } from "@exonn/js-sdk";
import type { StorageKey } from "@exonn/storage";
import { memoryStorageDriver } from "src/storage/memoryStorage.driver.ts";

export const getUserDataCache = <V = any>({
  user,
  key,
}: {
  user: UserResource;
  key: StorageKey;
}): V | null => {
  return memoryStorageDriver.get<V>({
    name: `user-data-${user.id}-${key.name}`,
    version: key.version,
  });
};
